var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlug(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M312 24C312 10.75 301.25 0 288 0S264 10.75 264 24V112H312V24ZM120 24C120 10.75 109.25 0 96 0S72 10.75 72 24V112H120V24ZM360 144H24C10.745 144 0 154.745 0 168V168C0 181.255 10.745 192 24 192H32V256C32 336.125 91.125 401.875 168 413.625V488C168 501.255 178.745 512 192 512H192C205.255 512 216 501.255 216 488V413.625C292.875 401.875 352 336.125 352 256V192H360C373.255 192 384 181.255 384 168V168C384 154.745 373.255 144 360 144ZM304 256C304 317.875 253.875 368 192 368S80 317.875 80 256V192H304V256Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlug);
export default __webpack_public_path__ + "static/media/plug.a2ca79cbd955c41ce05682030ded930c.svg";
export { ForwardRef as ReactComponent };